import {
  GenerateCaseworkerDashboardParams,
  GenerationCaseWorkerTasksParams,
  GenerationEnum,
} from '@repo/shared/events/generation'
import { DataStatus } from '@repo/ui/utils'

import { getCaseWorkerFilter, storeActions } from '@/store/actions'
import { getCurrentOrganization } from '@/store/helpers'
import { initHandleSocketAction } from '@/store/middlewares/helpers'
import { Action, ISocket, MiddlewareType } from '@/store/middlewares/types'
import { GenerateCaseWorkerTasksPayload, GenerationPayload } from '@/store/thunks/assistant'

export const socketIOMiddleware =
  (UseSocket: ISocket): MiddlewareType =>
  // @ts-expect-error not easy to type correctly
  (store) => {
    return (next) => (action: Action) => {
      const newAction = next(action) // Required to be called at very first place

      const state = store.getState()
      const organization = getCurrentOrganization(state)
      const user = state.user.me
      const isAuthenticated = DataStatus.isFulfilled(user)
      const caseWorker = state.user.caseWorker
      const isCaseWorkerLoaded = DataStatus.isFulfilled(caseWorker)

      if (!(isAuthenticated && DataStatus.isFulfilled(organization) && isCaseWorkerLoaded))
        return newAction

      const organizationId = organization.id

      const handleSocketAction = initHandleSocketAction({ store, UseSocket })

      if (
        action.type === storeActions.assistant.generate.dashboard.beneficiaryProfiles.start.type
      ) {
        const { generationId } = action.payload as GenerationPayload
        if (!generationId) return
        if (generationId !== state.assistant.generationId) return

        handleSocketAction<GenerateCaseworkerDashboardParams>({
          key: GenerationEnum.GenerateCaseworkerDashboard,
          emitPayload: {
            generationId,
            organizationId,
            userId: user.id,
            asCaseWorkerId: getCaseWorkerFilter({
              targetCaseWorkerId: caseWorker.id,
              caseWorker,
            }),
          },
          endAction: storeActions.assistant.generate.dashboard.beneficiaryProfiles.end,
          // TODO: ALEXIS
          // onItemReceived:
          //   storeActions.assistant.add.dashboard.beneficiaryProfile,
        })
      }

      if (action.type === storeActions.assistant.generate.beneficiary.caseWorkerTasks.start.type) {
        const currentBeneficiaryId = state.beneficiary.currentBeneficiaryId
        if (!currentBeneficiaryId) return
        const { generationId, previouslyGeneratedTasks } =
          action.payload as GenerateCaseWorkerTasksPayload
        if (!generationId) return

        if (generationId !== state.assistant.generationId) return

        handleSocketAction<GenerationCaseWorkerTasksParams>({
          key: GenerationEnum.GenerateCaseWorkerTasks,
          emitPayload: {
            beneficiaryId: currentBeneficiaryId,
            generationId,
            organizationId: organization.id,
            userId: user.id,
            previouslyGeneratedTasks,
          },
          endAction: storeActions.assistant.generate.beneficiary.caseWorkerTasks.end,
        })
      }

      return newAction
    }
  }
